<template>
    <div class="cc" :class="[{'top':type=='top'},{'bottom':type=='bottom'}]">
           <slot></slot>
    </div>
</template>
<script>
export default {
    props:['type'],
    mounted(){      
    }
}
</script>
<style lang="scss" scoped>
   .cc{
     display: flex;
     align-items: center;
     justify-content: center;
     height: 100%;
     &.top{
       align-items: flex-start;
     }
      &.bottom{
       align-items: flex-end;
     }
   }
</style>